// extracted by mini-css-extract-plugin
export default {"container":"AllGroups_container__6P+kV"};